// Navigation component for tab switching between Data Management and Dashboard

import { Link, useLocation } from "react-router-dom";

const Navigation = () => {
  const location = useLocation();

  const tabs = [
    {
      id: "dashboard",
      path: "/dashboard",
      name: "Dashboard",
      icon: (
        <svg
          className="w-5 h-5 inline mr-2"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
        </svg>
      ),
    },
    {
      id: "data",
      path: "/data",
      name: "จัดการข้อมูลรถ",
      icon: (
        <svg
          className="w-5 h-5 inline mr-2"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
    {
      id: "fuel",
      path: "/fuel",
      name: "จัดการข้อมูลน้ำมัน",
      icon: (
        <svg
          className="w-5 h-5 inline mr-2"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
  ];

  return (
    <div className="bg-white rounded-xl shadow-lg mb-8">
      <div className="flex border-b border-gray-200">
        {tabs.map((tab) => {
          const isActive = location.pathname === tab.path;

          return (
            <Link
              key={tab.id}
              to={tab.path}
              className={`px-6 py-4 text-sm font-medium transition-colors duration-200 ${
                isActive
                  ? "text-blue-600 border-b-2 border-blue-600 bg-blue-50"
                  : "text-gray-500 hover:text-gray-700 hover:bg-gray-50"
              }`}
            >
              {tab.icon}
              {tab.name}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default Navigation;
